define([
  'jsx!sumo/dom/Resize',
  'jsx!sumo/dom/ContentEditable',
  'jsx!sumo/dom/SVGImage',
], (Resize, ContentEditable, SVGImage) => {
  return {
    Resize,
    ContentEditable,
    SVGImage,
  };
});
